import React from 'react'
import { Box, Container, Typography, Card, CardMedia, CardContent } from '@mui/material'
import { PROJECTS } from '../content/Content'
import { motion } from 'framer-motion'
import { Colors } from '../constants/Colors'

const ProjectCard: React.FC<{
   image: string
   title: string
   description: string
   index: number
}> = ({ image, title, description, index }) => (
   <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.2 }}
   >
      <Card
         sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            boxShadow: 3,
            borderRadius: 2,
            transition: 'transform 0.3s, box-shadow 0.3s',
            '&:hover': {
               transform: 'scale(1.05)',
               boxShadow: `0 8px 20px ${Colors.RGBA_TRANSPARENT_BLACK}`,
            },
         }}
      >
         <CardMedia
            component="img"
            height="200"
            image={image}
            alt={title}
            sx={{
               objectFit: 'cover',
               borderTopLeftRadius: 2,
               borderTopRightRadius: 2,
            }}
         />
         <CardContent sx={{ flexGrow: 1 }}>
            <Typography
               variant="h5"
               gutterBottom
               sx={{ color: Colors.NAVY_BLUE, fontWeight: 'bold' }}
            >
               {title}
            </Typography>
            <Typography variant="body2" sx={{ color: Colors.DARK_GRAY }}>
               {description}
            </Typography>
         </CardContent>
      </Card>
   </motion.div>
)

const ProjectsPage: React.FC = () => (
   <Container maxWidth="lg" sx={{ mt: 8, mb: 8 }}>
      <Box textAlign="center" sx={{ mb: 6 }}>
         <Typography
            variant="h3"
            gutterBottom
            sx={{ color: Colors.NAVY_BLUE, fontWeight: 'bold' }}
         >
            {PROJECTS.title}
         </Typography>
         <Typography variant="h6" sx={{ color: Colors.DARK_GRAY, fontStyle: 'italic' }}>
            {PROJECTS.description}
         </Typography>
      </Box>
      <Box
         display="flex"
         flexWrap="wrap"
         justifyContent="center"
         gap={4}
         sx={{ rowGap: 4, columnGap: 4 }}
      >
         {PROJECTS.demos.map(({ image, title, description }, index) => (
            <Box
               key={index}
               flex="1 1 calc(33.333% - 32px)"
               maxWidth="calc(33.333% - 32px)"
               sx={{
                  minWidth: '300px',
               }}
            >
               <ProjectCard
                  image={image}
                  title={title}
                  description={description}
                  index={index}
               />
            </Box>
         ))}
      </Box>
   </Container>
)

export default ProjectsPage
